import { useEffect, useRef } from "react";
import { useAdsContext } from "../context";
import { filterAdSlots, createSlotRenderEndedListener } from "../utils/utils";
import { useFarbwelt } from "@/hooks";
import { useIsAdLeaderboardHidden } from "@/components/contacting/hooks/useIsAdLeaderboardHidden";
export const usePubstackAdsInit = () => {
    const { adSlots, setLoadedSlot } = useAdsContext();
    const isAdLeaderboardHidden = useIsAdLeaderboardHidden();
    const { isFarbweltActive } = useFarbwelt();
    const usedAdslots = filterAdSlots(adSlots, {
        isFarbweltActive,
        isAdLeaderboardHidden,
    });
    // used to prevent infinite loop
    const seenAdSlotIds = useRef(new Set());
    useEffect(() => {
        usedAdslots.forEach((ad) => {
            if (!seenAdSlotIds.current.has(ad.id)) {
                seenAdSlotIds.current.add(ad.id);
                setLoadedSlot(ad.id, "loading");
            }
        });
    }, [usedAdslots, setLoadedSlot]);
    // Listen for ad render events to track loaded slots
    useEffect(() => {
        // eslint-disable-next-line no-restricted-globals
        window.googletag = window.googletag || { cmd: [] };
        const handler = createSlotRenderEndedListener(setLoadedSlot);
        googletag.cmd.push(() => {
            googletag.pubads().addEventListener("slotRenderEnded", handler);
        });
        return () => {
            googletag.cmd.push(() => {
                googletag.pubads().removeEventListener("slotRenderEnded", handler);
            });
        };
    }, [setLoadedSlot]);
    useEffect(() => {
        // eslint-disable-next-line no-restricted-globals
        window.dispatchEvent(new CustomEvent("monetization_ready"));
    }, []);
};
